// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const createVehicle = (
  modelId: number,
  registration: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.post(`/v4/users/vehicles`, {
    model_id: modelId,
    registration
  });
};

export default createVehicle;
